import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaErrorFn = /* @__PURE__ */ createRecipe('textarea-error', {}, [])

const textareaErrorVariantMap = {}

const textareaErrorVariantKeys = Object.keys(textareaErrorVariantMap)

export const textareaError = /* @__PURE__ */ Object.assign(memo(textareaErrorFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaError',
  __getCompoundVariantCss__: textareaErrorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaErrorVariantKeys,
  variantMap: textareaErrorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaErrorVariantKeys)
  },
  getVariantProps: textareaErrorFn.getVariantProps,
})